
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IInfoCardAction, IInfoCardActionCriteria, IInfoCardData, IInfoCardSaveCriteria, IInfoCardSearchCriteria, IInfoTable, ISearchCriteria } from "@tylertech/tyler-api-types";

/**
 * InfoCardService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InfoCardService {
    private readonly $apiService = inject(ApiService);
    
    Get(pCriteria: IInfoCardSearchCriteria): Promise<IInfoCardData> {
        return this.$apiService.sendAuth("IInfoCardService/Get", pCriteria);
    }
    GetAddActions(pCriteria: ISearchCriteria<IInfoCardData>): Promise<IInfoCardAction[]> {
        return this.$apiService.sendAuth("IInfoCardService/GetAddActions", pCriteria);
    }
    GetCollection(pCriteria: IInfoCardSearchCriteria): Promise<IInfoCardData[]> {
        return this.$apiService.sendAuth("IInfoCardService/GetCollection", pCriteria);
    }
    GetDetailTable(pCriteria: IInfoCardSearchCriteria): Promise<IInfoTable> {
        return this.$apiService.sendAuth("IInfoCardService/GetDetailTable", pCriteria);
    }
    GetMultiSelectActions(pCriteria: ISearchCriteria<IInfoCardData>): Promise<IInfoCardAction[]> {
        return this.$apiService.sendAuth("IInfoCardService/GetMultiSelectActions", pCriteria);
    }
    GetNewEntity(pCriteria: IInfoCardSearchCriteria): Promise<IInfoCardData> {
        return this.$apiService.sendAuth("IInfoCardService/GetNewEntity", pCriteria);
    }
    PerformAction(pCriteria: IInfoCardActionCriteria): Promise<string> {
        return this.$apiService.sendAuth("IInfoCardService/PerformAction", pCriteria);
    }
    Save(pCriteria: IInfoCardSaveCriteria): Promise<IInfoCardData> {
        return this.$apiService.sendAuth("IInfoCardService/Save", pCriteria);
    }
}
